'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TransmuteCollection = require('./TransmuteCollection');

_TransmuteCollection.filter.implement(Array, function (test, arr) {
  return arr.filter(test);
});

_TransmuteCollection.filter.implementInherited(_immutable.Iterable, function (test, iter) {
  return iter.filter(test);
});

_TransmuteCollection.filter.implement(Object, function (test, obj) {
  var result = {};
  var keys = Object.keys(obj);
  var len = keys.length;
  for (var i = 0; i < len; i++) {
    var key = keys[i];
    var val = obj[key];
    if (test(val, key, obj)) {
      result[key] = val;
    }
  }
  return result;
});

_TransmuteCollection.filter.implementInherited(_immutable.Record, function (test, rec) {
  return rec.reduce(function (acc, val, key) {
    if (!test(val, key, rec)) {
      return acc;
    }
    return acc.set(key, val);
  }, (0, _immutable.Map)());
});

exports.default = _TransmuteCollection.filter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_filter.js
// module id = 43
// module chunks = 0 1